import useApi from "../../index";

const useNavBarActions = () => {
  const { useServices } = useApi();
  const { useNavBarServices } = useServices();
  const {
    getNavBarItemsService
  } = useNavBarServices();

  const actGetNavBarOptions = (permissions, role, onSuccess, onError) => async () => {
    try {
      const response = await getNavBarItemsService(permissions, role);
      onSuccess && onSuccess(response.data);
    } catch (error) {
      onError && onError(error);
    }
  };


  return {
    actGetNavBarOptions
  };
};

export default useNavBarActions;
